import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: 10,
    },
    loadmore: {
      color: "#6B46E5",
      fontSize: 30,
      paddingTop: 20,
      paddingBottom: 20,
    },
    textCenter: {
      textAlign: "center",
    },
    noText: {
      fontSize: 14,
      color: "gray",
      paddingTop: 140,
      textAlign: "center",
      paddingLeft: 6,
      paddingRight: 6,
      width: "100%",
      "& a": {
        fontSize: 14,
        color: "gray",
      },
    },
    filterContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "10px 20px",
      height: 44,
      width: "100%",
      backgroundColor: "#E0E0E0",
      position: "fixed",
      top: 44,
      left: 0,
      right: 0,
      zIndex: 99,
      maxWidth: 1024,
      margin: "0 auto",
      [theme.breakpoints.down("sm")]: {
        padding: "8px 10px",
        height: "auto",
        minHeight: 44,
        flexWrap: "wrap",
      },
    },
    filterButton: {
      color: "#000000",
      textTransform: "none",
      fontWeight: "bold",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.05)",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: 12,
        padding: "4px 8px",
        minWidth: "auto",
      },
    },
    radioGroup: {
      marginLeft: "auto",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    radio: {
      color: "#000000",
      "&.Mui-checked": {
        color: "#6B46E5",
      },
    },
    radioLabel: {
      color: "#000000",
      marginRight: 20,
      "& .MuiFormControlLabel-label": {
        fontSize: 14,
      },
    },
    sortButton: {
      display: "none",
      color: "#000000",
      textTransform: "none",
      fontWeight: "bold",
      marginLeft: "auto",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.05)",
      },
      [theme.breakpoints.down("sm")]: {
        display: "flex",
        fontSize: 12,
        padding: "4px 8px",
        minWidth: "auto",
      },
    },
  })
);

export default useStyles;
